// Slick Slider Initialisierung
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.product-slick-slider')) {
    $('.product-slick-slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
              arrows: false
          }
        }
      ]
    });
  }
});